module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-tabbar"
  }, [_c('div', {
    staticClass: "page-wrap"
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('mt-cell', {
    attrs: {
      "title": "当前选中",
      "value": _vm.selected,
      "wrapperpaddingleft": "20px"
    }
  })], 1), _vm._v(" "), _c('mt-tab-container', {
    staticClass: "page-tabbar-container",
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  }, [_c('mt-tab-container-item', {
    attrs: {
      "id": "外卖"
    }
  }, [_c('mt-cell-group', _vm._l((10), function(n) {
    return _c('mt-cell', {
      attrs: {
        "title": '餐厅 ' + n
      }
    })
  }))], 1), _vm._v(" "), _c('mt-tab-container-item', {
    attrs: {
      "id": "订单"
    }
  }, [_c('mt-cell-group', _vm._l((5), function(n) {
    return _c('mt-cell', {
      attrs: {
        "title": '订单 ' + n
      }
    })
  }))], 1), _vm._v(" "), _c('mt-tab-container-item', {
    attrs: {
      "id": "发现"
    }
  }, [_c('mt-cell-group', _vm._l((7), function(n) {
    return _c('mt-cell', {
      attrs: {
        "title": '发现 ' + n
      }
    })
  }))], 1), _vm._v(" "), _c('mt-tab-container-item', {
    attrs: {
      "id": "我的"
    }
  }, [_c('div', {
    staticClass: "page-part"
  }, [_c('mt-cell-group', _vm._l((12), function(n) {
    return _c('mt-cell', {
      attrs: {
        "title": '我的 ' + n
      }
    })
  }))], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('mt-button', {
    attrs: {
      "type": "danger",
      "size": "large"
    }
  }, [_vm._v("退出")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('mt-tabbar', {
    attrs: {
      "fixed": ""
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  }, [_c('mt-tab-item', {
    attrs: {
      "id": "外卖",
      "icontype": "home"
    }
  }, [_vm._v("\n      外卖\n    ")]), _vm._v(" "), _c('mt-tab-item', {
    attrs: {
      "id": "订单",
      "icontype": "lingdaorichengicon"
    }
  }, [_c('mt-badge', {
    attrs: {
      "slot": "badge",
      "size": "normal",
      "padding": "3px",
      "color": "red"
    },
    slot: "badge"
  }), _vm._v("\n      订单\n    ")], 1), _vm._v(" "), _c('mt-tab-item', {
    attrs: {
      "id": "发现"
    }
  }, [_c('img', {
    attrs: {
      "slot": "icon",
      "src": require("../assets/100x100.png")
    },
    slot: "icon"
  }), _vm._v(" "), _c('mt-badge', {
    attrs: {
      "slot": "badge",
      "size": "normal",
      "padding": "3px",
      "color": "red"
    },
    slot: "badge"
  }), _vm._v("\n      发现\n    ")], 1), _vm._v(" "), _c('mt-tab-item', {
    attrs: {
      "id": "我的",
      "icontype": "wodezixun"
    }
  }, [_vm._v("\n      我的\n    ")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a651de9e","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./example/pages/tabbar.vue
// module id = 631
// module chunks = 0